var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#141414"
    }
  }, [_c('b-container', [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bg",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "noPadding"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "resp",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])
  }))], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align-v": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logoFooter.png")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/",
      "title": "facebook"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/fbBlack.png")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/",
      "title": "tweeter"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/tweeterBlack.png")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://plus.google.com/discover",
      "title": "google plus"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/googleBlack.png")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://hexagon.com/news/social-media",
      "title": "hexagon"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/hexagonBlack.png")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://pl.pinterest.com/",
      "title": "pinterest"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/picsaBlack.png")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/features",
      "title": "snapchat"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/gitBlack.png")
    }
  })])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "12"
    }
  }, [_c('hr')])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4948859d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Myfooter.vue
// module id = +FAF
// module chunks = 0